'use strict';

var $ = require('jquery');
require('../../utils/jquery-extensions');
var login = require('../login');
var multipleVariations = require('./multiplevariations');
var applePay = require('../checkout/applepay_ui');
var deliveryEstimate = require('../../components/checkout/estimatedelivery');
var dytracking = require('../../components/tracking/dytracking');
const wishlist = require('../wishlist');
const util = require('../../utils/util');
const googlepay = require('../checkout/googlepay_ui');
const flyinstorelocator = require('../../productdetail/flyin-storelocator');
const bopisTracking = require('../../components/tracking/bopis');

import {debounce} from '../../components/custom-lodash';

/* function payNextSuccessCallback(response) {
    var paymentToken = response.PaymentToken;
    var $paynextWidgetContainer = $('.cart-action-checkout-ppexpress .paynext-widget');
    var $errorContainer = $('#paynext-errors');

    if ($errorContainer.length > 0) {
        $errorContainer.empty();
    }

    if (paymentToken && $paynextWidgetContainer.length > 0) {
        if (!window.payNext.succeeded) {
            window.payNext.succeeded = true;
            $('.checkout-payment-token').val(paymentToken);
            $('#paypal-express-checkout').unbind('click');
            $('#paypal-express-checkout').click();
        }
    }
} */

/* function payNextErrorCallback(response) {
    var errors;
    var $errorContainer = $('#paynext-errors');
    var $innerErrorContainer = $errorContainer.find('.paynext-error');
    var i;

    if ($innerErrorContainer.length > 0) {
        $innerErrorContainer.empty();
    } else {
        $errorContainer.append($('<div class="message error-form paynext-error"></div>'));
        $innerErrorContainer = $errorContainer.find('.paynext-error');
    }

    if (response.Error.InnerErrors) {
        errors = $.makeArray(response.Error.InnerErrors);
        for (i = 0; i < errors.length; i++) {
            $innerErrorContainer.append(errors[i].Message);
            $innerErrorContainer.append('<br/>');
        }
    } else {
        $innerErrorContainer.html(response.Error.Message);
    }

    $('html, body').animate({
        scrollTop: $('#paynext-errors').offset().top - 150
    }, 1000);
} */

/* function payNextRenderErrorCallback(error) {
    console.log('payNextRenderErrorCallback');
    console.log(error);
} */

/**
 * @private
 * @function
 * @description get PayNext Api Options
 */
/* function getWidgetApiOptions(widgetConf) {
    var widgetApiOptions = new window.Arvato.PayNext.WidgetApiOptions();
    widgetApiOptions.tokenizationServiceUrl = widgetConf.host + '/' + widgetConf.merchantId +
            '/Pmg.Site/WidgetApi/Home/Index';
    widgetApiOptions.securityToken = widgetConf.merchantToken;
    widgetApiOptions.placeHolder = widgetConf.contentSelector;
    widgetApiOptions.countryCode = widgetConf.countryCode;
    widgetApiOptions.currencyCode = widgetConf.currencyCode;
    widgetApiOptions.culture = widgetConf.culture;
    widgetApiOptions.cssUrl = widgetConf.cssURL;
    widgetApiOptions.displayPaymentMethodsLogo = false;
    widgetApiOptions.displayValidationErrors = false;
    widgetApiOptions.paymentMethods = widgetConf.widgetPaymentMethods;
    widgetApiOptions.clearFrameAfterSuccessfulPayment = true;
    widgetApiOptions.frameWidth = widgetConf.width;
    widgetApiOptions.frameHeight = widgetConf.height;
    widgetApiOptions.timeOut = 0; // 3000;
    widgetApiOptions.showCvcHint = false; // optional; default false; optional
    widgetApiOptions.busyIndicator = true; // optional; if "0" or "no" no busy indicator will be in place
    widgetApiOptions.renderErrorCallback = payNextRenderErrorCallback;
    widgetApiOptions.renderSuccessCallback = ''; // not implemented yet
    widgetApiOptions.errorCallback = payNextErrorCallback;
    widgetApiOptions.successCallback = payNextSuccessCallback;

    return widgetApiOptions;
} */

/**
 * @private
 * @function
 * @description initialize PayNext for PayPal Express
 */
/* function initPayNextPPExpress() {
    var $paynextWidgetContainer = $('.cart-action-checkout-ppexpress .paynext-widget'),
        widgetConf,
        widgetAPI;

    if ($paynextWidgetContainer.length > 0) {
        widgetConf = $paynextWidgetContainer.data('widget-configuration');
        widgetAPI = widgetConf.host + '/' + widgetConf.merchantId + widgetConf.widgetAPI;

        $.getScript(widgetAPI, function () {
            var widgetApiOptions = getWidgetApiOptions(widgetConf);

            if (!window.payNext) {
                window.payNext = {};
            }
            window.payNext[widgetConf.paymentMethod] = new window.Arvato.PayNext.WidgetApi(widgetApiOptions);
            window.payNext[widgetConf.paymentMethod].render();

            $('#paypal-express-checkout').click(function (event) {
                event.preventDefault();
                window.payNext[widgetConf.paymentMethod].tokenize();
            });

            setTimeout(function () {
                $('#paypal-express-checkout').removeAttr('disabled');
            }, 1500);
        });
    }
} */

/**
 * @private
 * @function
 * @description Binds events to the cart page (edit item's details, bonus item's actions, coupon code entry)
 */
function initializeEvents() {
    var cg = 'cart-guestcheckout';
    var $toggles = $('.js-toggle');
    var $toggleTitle = $('.js-toggle-sub');
    var $toggleContainers = $('.grid-checkout').find('.js-tooglecontainer');
    var $closedByDefault = $toggleContainers.not('.expanded').find('.form-section');

    dytracking.setRecentlyViewedSelector('cart');

    let headerHeigth = $('.header-wrapper').height();

    if ($('.cart-guestcheckout-group .message.error-form').length) {
        let targetHeight = $('.order-totals-line.order-total').offset().top;
        window.scrollTo(0, targetHeight - headerHeigth);

        if ($('.memberexclusive.error-form').length) {
            $('#checkout-form button[name$="_checkoutCart"]').removeAttr('disabled');
        }
    }

    if (util.isMobile() && $('.coupon-error-msg').length) {
        let marginAndHeader = 30 + headerHeigth;
        window.scrollTo(0, $('.cart-coupon-code').offset().top - marginAndHeader);
    }

    let dhlSignInLink = $('.dhl-sign-in-link');

    if (dhlSignInLink.length) {
        const membersOnlyFlyin = require('../../flyins/membersonlyflyin');

        dhlSignInLink.on('click', function (e) {
            membersOnlyFlyin.init(e.target);
            return;
        });
    }

    if (applePay.isApplePaySession()) {
        $('.two-steps-applepay').show();
    } else {
        $('.two-steps-applepay').remove();
    }

    $toggleTitle.on('click', function (e) {
        var $toggle = $(this).closest('.js-toggle');
        var $toggleContainer = $toggle.find('.js-tooglecontainer');

        if ($(window).width() < 1023) {
            if (!$toggleContainer.hasClass('expanded')) {
                $toggles.not($toggle).find('.js-tooglecontainer').removeClass('expanded');
                $toggles.not($toggle).find('.form-section').slideUp();
                $toggleContainer.addClass('expanded');
                $toggleContainer.find('.form-section').slideDown();
            } else {
                $toggleContainer.removeClass('expanded');
                $toggleContainer.find('.form-section').slideUp();
            }
        }
    });

    if ($(window).width() < 1023) {
        $('#checkout-login-button').removeClass('button-trans');
        $('#customer-create-button').removeClass('button-trans');
        $closedByDefault.slideUp();
    }

    $(window).on(
        'resize',
        debounce(function () {
            if ($(window).width() > 1023) {
                $('#checkout-login-button').addClass('button-trans');
                $('#customer-create-button').addClass('button-trans');
                $toggleContainers.find('.form-section').slideDown();
            } else {
                $('#checkout-login-button').removeClass('button-trans');
                $('#customer-create-button').removeClass('button-trans');
                $toggleContainers.not('.expanded').find('.form-section').slideUp();
            }
        }, 300)
    );

    $(document).ready(function () {
        $('.jsQtyUpdate')
            .change(function (e) {
                let previousValue = $(this).data('previousValue');
                $(e.target).closest('form').find('button:first').trigger('click');
                $('.jsQtyUpdate.uniformstyled').focus();
                let selectedValue = $(this).val();
                let container = $(this).closest('.row-product');
                let pid = container.find('input[name="minicartPid"]').val();
                if (selectedValue > previousValue) {
                    sessionStorage.setItem('itemsAdded', selectedValue - previousValue);
                } else if (selectedValue < previousValue) {
                    sessionStorage.setItem('itemsRemoved', previousValue - selectedValue);
                }
                sessionStorage.setItem('pid', pid);
                $(this).data('previousValue', selectedValue);
            })
            .each(function () {
                $(this).data('previousValue', $(this).val());
            });
    });
    // override enter key for coupon code entry
    $('form input[name$="_couponCode"]').on('keydown', function (e) {
        if (e.which === 13) {
            if ($(this).val().length === 0) {
                // don't trigger any action (SG default)
                return false;
            }
            // trigger the right action (add coupon)
            e.preventDefault();
            $('.jsApplyCoupon').trigger('click');
            return false;
        }
    });

    // switch coupon button state
    $('form input[name$="_couponCode"]').on('input', function () {
        var placeHolder = $(this).attr('placeholder');
        var value = $(this).val();
        var applyButton = $(this).closest('.cart-coupon-code-form').find('button#add-coupon');

        if (value !== '' && value !== placeHolder && value.replace(/\s/g, '').length !== 0) {
            applyButton.removeClass('disabled');
            applyButton.prop('disabled', false);
        } else {
            applyButton.addClass('disabled');
            applyButton.prop('disabled', true);
        }
    });

    // show / hide login for guest checkout radio selection
    $('.' + cg).on('change', 'input[type=radio]', function (e) {
        var $target = $(e.target);
        var $targetGroup = $('.' + cg + '-group');
        var $oauthCtnr = $('.login-oauth');

        let membersExclusiveErr = $('.memberexclusive.error-form').length;
        let checkoutBtn = $('#checkout-form button[name$="_checkoutCart"]');

        if ($target.attr('id') === cg + '-false') {
            $targetGroup.slideDown();
            $oauthCtnr.slideDown();
            $('label[for="' + cg + '-true"]').attr('aria-checked', 'false');
            $('label[for="' + cg + '-false"]').attr('aria-checked', 'true');

            if (membersExclusiveErr) {
                checkoutBtn.removeAttr('disabled');
            }
        } else {
            $('label[for="' + cg + '-true"]').attr('aria-checked', 'true');
            $('label[for="' + cg + '-false"]').attr('aria-checked', 'false');

            $targetGroup.slideUp();
            $oauthCtnr.slideUp();

            if (membersExclusiveErr) {
                checkoutBtn.prop('disabled', true);
            }
        }
    });

    // transmit form with guest checkout selection and login credentials
    // if user is not authenticated yet (so form is present)
    if ($('.' + cg + '-form').length > 0) {
        $('.main').on('submit', '.cart-action-checkout', function (e) {
            e.preventDefault();
            $('.' + cg + '-button').trigger('click');
        });
    }

    $('.cart-gift-certificate-info').on('click', function (e) {
        $(this).toggleClass('is-expanded');
    });

    if ((sessionStorage.itemsAdded || sessionStorage.itemsRemoved) && sessionStorage.pid) {
        // checking if the quantity was changed and calling the add-to-cart event in dytracking
        dytracking.quantityChangeCart();
        if (sessionStorage.itemsAdded) {
            sessionStorage.removeItem('itemsAdded');
        }
        if (sessionStorage.itemsRemoved) {
            sessionStorage.removeItem('itemsRemoved');
        }
        sessionStorage.removeItem('pid');
    }
    var currency = $('input[name="currency"]').val();
    dytracking.syncCart(currency || '');

    $('.xlt-removeBasketItem.button.button-remove').on('click', function () {
        var container = $(this).closest('.row-product');
        if (container.length > 0) {
            dytracking.trackCartRemove(container);
        }
    });

    const container = document.getElementById('googlepay-wrapper');

    if (container) {
        googlepay.init();
    }
    // If the user clicks forgot password and then he clicks
    // the back button we want the fist option to be preselected.
    $('.forgot-password').on('click', () => {
        $('#cart-guestcheckout-true').trigger('click');
    });
}
/**
 * Init paypal express button
 *
 * @returns {void}
 */
function initPayPalExpress() {
    $('.js_paypal_button').each(function () {
        let $btn = $(this);
        if ($btn.data('isInited')) {
            return;
        }
        let config = $btn.data('paypalConfig');
        if (typeof config !== 'object' || config === null) {
            console.error('paypalUtils: not valid data-paypal-config');
            return;
        }
        if (!config.locale && window?.Constants?.LOCALE) {
            config.locale = window.Constants.LOCALE;
            if (window?.Constants?.PP_LOCALES) {
                config.locale = window.Constants.PP_LOCALES[config.locale] || config.locale;
            }
        }

        paypalUtils.initButton(config, $btn[0]);
        $btn.data('isInited', true);
    });
}
exports.init = function () {
    initializeEvents();
    // allColumnsVisible();
    wishlist.initWishlistCart();
    login.initCartLogin();
    multipleVariations.init();
    // PayNext widged API not available by now
    // initPayNextPPExpress();
    //Include Narvar estimate delivery form handling events
    deliveryEstimate.init();
    flyinstorelocator.init();
    bopisTracking.initCartEvents();
    initPayPalExpress();
};
